<template>
  <fieldset class="tla-form-group" v-if="showComponent">
    <div class="pre-sub-consent">
      <span class="pre-sub-consent__text" v-html="policyText"></span>
      <label class="tla-check" :for="`${policyTypeName}-OptInAll`">
        <input class="tla-check__checkbox" :id="`${policyTypeName}-OptInAll`" type="checkbox" v-validate.initial="isMandatory ? 'required' : ''" v-model="consent"/>
        <div class="tla-check__indicator"></div>
      </label>
    </div>
  </fieldset>
</template>

<script lang="ts">
import {
  Component, Prop, Vue, Watch
} from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import OptInData from '@/models/OptInData';

const InitialSettingsModule = namespace('initialSettingsModule');
const EnquiryModule = namespace('enquiryModule');

@Component
export default class MandatoryConsentComponent extends Vue {
  @InitialSettingsModule.Getter public initialSettings;

  @EnquiryModule.Action public submitOptInConsent;

  @Prop({ default: false })
  public isPartner!: boolean;

  @Prop({ default: false })
  public isMandatory!: boolean;

  @Prop({ default: null })
  public publishedPolicyVersionId!: string;

  @Prop({ default: null })
  public publishedPolicyVersionContent!: string;

  @Prop({
    default: () => []
  })
  public allowedManufacturerIds!: number[];

  private consent: boolean = false;

  private policyText: string = '';

  private optInData = new OptInData();

  public get policyTypeName(): string {
    return `policy-${this.isPartner ? 'partner' : 'tla'}-${this.hasAllowedManufacturers ? this.allowedManufacturerIds.join('-') : 'all'}`;
  }

  @Watch('consent')
  public updateConsentOption(value: boolean) {
    this.optInData.OptInEmail = value;
    this.optInData.OptInPhone = value;
    this.optInData.OptInPost = value;
    this.optInData.OptInSms = value;
    this.submitOptInConsent(this.optInData);
  }

  public get hasValidPolicyOverride(): boolean {
    if (this.publishedPolicyVersionId
      && this.publishedPolicyVersionId.length > 0
      && this.publishedPolicyVersionContent
      && this.publishedPolicyVersionContent.length > 0) {
      return true;
    }

    return false;
  }

  public get hasAllowedManufacturers(): boolean {
    return this.allowedManufacturerIds && this.allowedManufacturerIds.length > 0;
  }

  public get currentManufacturerId(): number {
    return this.$store.getters['vehicleModule/currentManufacturerId'];
  }

  public get isAllowedManufacturer(): boolean {
    if (this.hasAllowedManufacturers) {
      return this.allowedManufacturerIds.includes(this.currentManufacturerId);
    }

    return true;
  }

  public get showComponent(): boolean {
    return this.isAllowedManufacturer
      && this.policyText.length > 0;
  }

  @Watch('currentManufacturerId')
  public setDefaultConsent() {
    if (this.showComponent) {
      this.submitOptInConsent(this.optInData);
    }
  }

  public created() {
    if (this.isPartner) {
      this.optInData.PolicyType = 3;

      if (this.hasValidPolicyOverride) {
        this.optInData.PublishedPolicyId = this.publishedPolicyVersionId;
        this.policyText = this.publishedPolicyVersionContent;
      } else {
        this.optInData.PublishedPolicyId = this.initialSettings.partnerMarketingPolicyVersionId;
        this.policyText = this.initialSettings.partnerMarketingPolicyVersionText;
      }
    } else {
      this.optInData.PolicyType = 1;

      if (this.hasValidPolicyOverride) {
        this.optInData.PublishedPolicyId = this.publishedPolicyVersionId;
        this.policyText = this.publishedPolicyVersionContent;
      } else {
        this.optInData.PublishedPolicyId = this.initialSettings.marketingPolicyVersionId;
        this.policyText = this.initialSettings.marketingPolicyVersionText;
      }
    }

    this.setDefaultConsent();
  }
}
</script>
